import { RowExportTypePdf } from "types";
import { convertNumber } from "utils";
import { PdfTemplate } from "components";
import { PromiseToComeResponse } from "../../types";
import moment from "moment";

export function ExportPdfPromiseToCome({ dataList }: {
    dataList: PromiseToComeResponse['data'],
}) {

    const columns = [
        { header: 'NO', key: 'no', width: 5 },
        { header: 'CODE', key: 'code', width: 10 },
        { header: 'VENDOR NAME', key: 'vendor_name', width: 20 },
        { header: 'PO ID', key: 'po_id', width: 20 },
        { header: 'ORDER DATE', key: 'order_date', width: 20 },
        { header: 'TOTAL QTY', key: 'total_qty', width: 20 },
        { header: 'PROMISE DATE', key: 'promise_date', width: 20 },
    ];

    const dataMap: RowExportTypePdf[] = dataList.map((item, index) => ({
        no: index + 1,
        code: item.vendor_code,
        vendor_name: item.vendor_name,
        po_id: item.trx_code,
        order_date: moment(item.transaction_date).format('DD/MM/YYYY'),
        total_qty: {
            text: convertNumber(item.total_qty ?? 0).intoNormalAmount,
            style: { textAlign: "right" }
        },
        promise_date: moment(item.promize_date).format('DD/MM/YYYY'),
    }))

    return (
        <PdfTemplate
            data={dataMap}
            module="INVENTORY"
            title = "PURCHASE ORDER PROMISES TO COME"
            column={columns}
        />
    )
}